import { Dispatch, SetStateAction, useEffect } from 'react';

import { useDebouncedValue } from 'hooks/useDebouncedValue';

import { FormikValues, useFormikContext } from 'formik';

type DebouncedSearchTriggerProps<T> = {
  isFinalSelection?: (val: T, options: Array<T>) => boolean;
  searchFastigheter: (q: string) => void;
  fastighetOptions: Array<T>;
  setIsCleared: Dispatch<SetStateAction<boolean>>;
  setIsIncompleteFastighetsbeteckning: Dispatch<SetStateAction<boolean>>;
  isCleared: boolean;
};

export const DebouncedSearchTrigger = <T,>({
  searchFastigheter,
  isFinalSelection,
  fastighetOptions,
  setIsCleared,
  setIsIncompleteFastighetsbeteckning,
  isCleared = false
}: DebouncedSearchTriggerProps<T>) => {
  const { values } = useFormikContext<FormikValues>();
  const debouncedBeteckning = useDebouncedValue(values.beteckning, 300);

  const isQueryFinal = isFinalSelection && isFinalSelection(debouncedBeteckning, fastighetOptions);

  useEffect(() => {
    setIsIncompleteFastighetsbeteckning(values.beteckning && !isQueryFinal);
  }, [isQueryFinal, setIsIncompleteFastighetsbeteckning, values.beteckning]);

  useEffect(() => {
    if (!values.beteckning) {
      setIsCleared(false);
    }
  }, [setIsCleared, values.beteckning]);

  useEffect(() => {
    if (!debouncedBeteckning || isQueryFinal || isCleared) {
      return;
    }

    void searchFastigheter(debouncedBeteckning);
  }, [debouncedBeteckning, isQueryFinal, isCleared, searchFastigheter]);

  return null;
};
